
import type {
  ManagerScheduledOrder,
  ScheduledOrdersApiItem,
  ScheduledOrdersApiResponse,
} from "../interface/ScheduledOrder ";

export const toNumber = (value: unknown): number => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatFilterDate = (
  date: Date | null
): string | undefined => {
  if (!date) return undefined;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatScheduleDate = (
  value?: string | null
): string => {
  if (!value || value === "-") return "--";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatScheduleTime = (
  value?: string | null
): string => {
  if (!value || value === "-") return "--";

  const match = value.match(
    /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/
  );

  if (match) {
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    const seconds = Number(match[3] ?? 0);

    if (hours > 23 || minutes > 59 || seconds > 59) {
      return value;
    }

    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDateTime = (
  value?: string | null
): string => {
  if (!value || value === "-") return "--";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const mapScheduledOrder = (
  item: ScheduledOrdersApiItem
): ManagerScheduledOrder => ({
  id: toNumber(item.id ?? item.caseID ?? item.CaseID),
  caseID: toNumber(item.caseID ?? item.CaseID),
  orderId: item.orderId ?? item.orderID ?? item.OrderID ?? "--",
  type: item.type ?? item.orderTypeName ?? item.OrderTypeName ?? "--",
  scheduleDate: item.scheduleDate ?? item.ScheduleDate ?? "",
  scheduleTime: item.scheduleTime ?? item.ScheduleTime ?? "",
  scheduleEndTime:
    item.scheduleEndTime ?? item.ScheduleEndTime ?? "",
  status: item.status ?? item.Status ?? "--",
  clinic: item.clinic ?? item.clinicName ?? item.ClinicName ?? "--",
  clinicMobileNo:
    item.clinicMobileNo ?? item.ClinicMobileNo ?? "--",
  clinicAddress:
    item.clinicAddress ?? item.ClinicAddress ?? "--",
  paymentStatus:
    item.paymentStatus ?? item.PaymentStatus ?? "--",
  originalAmount: toNumber(
    item.originalAmount ??
      item.OriginalAmount ??
      item.amount ??
      item.Amount
  ),
  discountAmount: toNumber(
    item.discountAmount ?? item.DiscountAmount
  ),
  couponPercentage: toNumber(
    item.couponPercentage ?? item.CouponPercentage
  ),
  paidAmount: toNumber(item.paidAmount ?? item.PaidAmount),
  createdTime: item.createdTime ?? item.CreatedTime ?? "",
});
